package app.nestbridge.feature.invitations.ui

import app.nestbridge.feature.invitations.screen.InvitationQrScanScreen
import app.nestbridge.feature.invitations.screen.InvitationQrScanState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class InvitationQrScanUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    is InvitationQrScanScreen -> ui<InvitationQrScanState> { state, modifier -> InvitationQrScanUi(state = state, modifier = modifier) }
    else -> null
  }
}
